import React from 'react'
import Sidebar from '../../components/AppSidebar'
import Header from '../../components/AppHeader'

export default function Sale() {
  return (
    <>
      <Sidebar />
      <div className="main-content">
        <Header title = 'Sales' />
      </div>
    </>
  )
}
